import React from 'react'
import { Breadcrumb, Tooltip } from 'antd'
import Icon from '../../icon'
import { TreeParentList } from '../treeList'
import './index.less'

export default ({ data, pathArr, scrollHeight, style, onGoBack, onLink, onNext, onChange, value, onCancelCollect, loading }) => {
  return <div className="tree-list-next" style={style}>
    <div className="tree-list-next-path">
      <div className="tree-list-next-path-back-btn" onClick={onGoBack}>
        <Icon type="m-Vxing_zuo" />
      </div>
      <div className="tree-list-next-path-link">
        <Breadcrumb className="mn-breadcrumb">
          <Tooltip title={pathArr[0].label}>
            <Breadcrumb.Item onClick={() => onLink(pathArr[0])}>
              {pathArr[0]?.keyWords ? <div style={{ display: 'flex' }}>含有&quot;<div style={{ maxWidth: '80px' }} className="text-overflow">{pathArr[0]?.keyWords}</div>&quot;的灵感集</div> : pathArr[0]?.label}
            </Breadcrumb.Item>
          </Tooltip>
          {
            pathArr.length > 3 ? <>
              <Breadcrumb.Item>
                ...
              </Breadcrumb.Item>
              {
                pathArr.slice(pathArr.length - 2, pathArr.length).map(item => <Tooltip title={item.label}>
                  <Breadcrumb.Item className="mn-breadcrumb-item text-overflow" onClick={() => onLink(item)}>
                    {item.label}
                  </Breadcrumb.Item>
                </Tooltip>)
            }
            </>
              : <>
                {
                pathArr.slice(1, pathArr.length).map(item => <Tooltip title={item.label}>
                  <Breadcrumb.Item className="mn-breadcrumb-item text-overflow" onClick={() => onLink(item)}>
                    {item.label}
                  </Breadcrumb.Item>
                </Tooltip>)
            }
              </>
          }
        </Breadcrumb>
      </div>
    </div>
    <TreeParentList
      loading={loading}
      data={data}
      scrollHeight={scrollHeight}
      onNext={onNext}
      value={value}
      onChange={onChange}
      onCancelCollect={onCancelCollect}
    />
  </div>
}
